import {registerLazyModule} from '@/appManager/index';


export const MOD_CHECKOUT       = 'a4d_checkout';
export const MOD_CONFIGURATOR   = 'a4d_configurator';
export const MOD_FORM_MANAGER   = 'a4d_form_manager';
export const MOD_SETTINGS       = 'a4d_settings';
export const MOD_SWATCH_MANAGER = 'a4d_swatch_manager';

export function registerVuexModules() {

    registerLazyModule(
        MOD_CHECKOUT,
        () => import(/* webpackChunkName: "mod_co" */ '@/vuex/store/modules/a4d_checkout/a4d_checkout')
    );
    registerLazyModule(
        MOD_CONFIGURATOR,
        () => import(/* webpackChunkName: "mod_cf" */ '@/vuex/store/modules/a4d_configurator/a4d_configurator')
    );
    registerLazyModule(
        MOD_FORM_MANAGER,
        () => import(/* webpackChunkName: "mod_form_mgr" */ '@/vuex/store/modules/a4d_form_manager/a4d_form_manager')
    );
    registerLazyModule(
        MOD_SETTINGS,
        () => import(/* webpackChunkName: "mod_settings" */ '@/vuex/store/modules/a4d_settings/a4d_settings')
    );
    registerLazyModule(
        MOD_SWATCH_MANAGER,
        () => import(/* webpackChunkName: "mod_swatch-mgr" */ '@/vuex/store/modules/a4d_swatch_manager/a4d_swatch_manager')
    );
}
